export const isDevelopment = process.env.NODE_ENV === "development" ;
export const isStaging = process.env.REACT_APP_ENV === "staging" ;
export const url =  isStaging ? "http://161.118.165.144/api/" : isDevelopment ? "http://localhost:3001/api/" : "https://autowizapp.com/api/";
export const socketUrl = isStaging
    ? "http://161.118.165.144"
    : isDevelopment
    ? "http://localhost:3001"
    : "https://autowizapp.com";
// export const url = "https://autowizapp.com/api/";